'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
// polyfill webpack require.ensure
if (typeof require.ensure !== 'function') require.ensure = function (deps, cbFn) {
  return cbFn(require);
};

var TopXListRoute = exports.TopXListRoute = function TopXListRoute() {
  return {
    path: 'lists',

    getIndexRoute: function getIndexRoute(location, callback) {
      require.ensure([], function (require) {
        callback(null, require('routes/NotFound').default());
      }, 'NotFound');
    },

    getChildRoutes: function getChildRoutes(location, callback) {
      require.ensure([], function (require) {
        callback(null, [{
          path: ':city',
          component: require('./TopXIndexContainer').TopXIndexContainer
        }, {
          path: ':city/*',
          component: require('./TopXListContainer').TopXListContainer
        }]);
      }, 'TopXList');
    }
  };
};